/**
 * @generated SignedSource<<7223607e5650e16672c708e0a552a814>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksHomeV2PickMorningStudioArticle$data = {
  readonly items: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"homeNativeArticleContentItemContent">;
      };
    }>;
  } | null | undefined;
  readonly " $fragmentType": "hooksHomeV2PickMorningStudioArticle";
};
export type hooksHomeV2PickMorningStudioArticle$key = {
  readonly " $data"?: hooksHomeV2PickMorningStudioArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksHomeV2PickMorningStudioArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksHomeV2PickMorningStudioArticle"
};

(node as any).hash = "80bd07361bc8addbdb8b7ca283efa585";

export default node;
